import Theme from 'Theme';
import { StyleSheet } from 'react-native';

const baseStyles = {
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 20,
        width: '100%'
    },
    textContainer: {
        flex: 1,
        marginRight: 20
    },
    titleStyle: {
        color: Theme.primaryTextColor,
        fontSize: 20,
        flexWrap: 'wrap'
    },
    hr: {
        borderBottomWidth: 1,
        borderBottomColor: 'black',
        marginHorizontal: 20
    },
    descriptionStyle: {
        color: Theme.secondaryTextColor,
        padding: 20,
        fontSize: 15
    }
};

export default StyleSheet.create(baseStyles);
